import { useEffect, useState } from "react";
import { Plus, Trash2, Tag } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function AdminCoupons() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ code: "", discount_percent: 20, max_uses: 100, expires_in_days: 30, active: true });

  const load = async () => { const { data } = await api.get("/admin/coupons"); setItems(data); };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/admin/coupons", form);
      setItems([data, ...items]);
      setForm({ code: "", discount_percent: 20, max_uses: 100, expires_in_days: 30, active: true });
      toast.success("Coupon created");
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };
  const remove = async (id) => { await api.delete(`/admin/coupons/${id}`); setItems(items.filter((i) => i.id !== id)); };

  return (
    <div className="px-5 lg:px-10 py-8 max-w-5xl mx-auto">
      <h1 className="text-3xl font-bold text-brand-navy">Coupons</h1>
      <form onSubmit={add} className="mt-6 bg-white rounded-2xl border border-brand-borderc p-5 grid md:grid-cols-5 gap-3 items-end">
        <div><label className="text-xs text-brand-muted">Code</label><input required value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} className="w-full px-3 py-2.5 rounded-xl border border-brand-borderc text-sm" /></div>
        <div><label className="text-xs text-brand-muted">Discount %</label><input type="number" min="1" max="100" value={form.discount_percent} onChange={(e) => setForm({ ...form, discount_percent: +e.target.value })} className="w-full px-3 py-2.5 rounded-xl border border-brand-borderc text-sm" /></div>
        <div><label className="text-xs text-brand-muted">Max uses</label><input type="number" value={form.max_uses} onChange={(e) => setForm({ ...form, max_uses: +e.target.value })} className="w-full px-3 py-2.5 rounded-xl border border-brand-borderc text-sm" /></div>
        <div><label className="text-xs text-brand-muted">Expires in days</label><input type="number" value={form.expires_in_days} onChange={(e) => setForm({ ...form, expires_in_days: +e.target.value })} className="w-full px-3 py-2.5 rounded-xl border border-brand-borderc text-sm" /></div>
        <button className="btn-primary-gradient rounded-full font-semibold py-2.5 inline-flex items-center justify-center gap-1"><Plus className="w-4 h-4" />Create</button>
      </form>

      <div className="mt-5 bg-white rounded-2xl border border-brand-borderc divide-y divide-brand-borderc">
        {items.length === 0 ? (
          <div className="text-center py-12 text-brand-muted"><Tag className="w-10 h-10 mx-auto text-brand-purple" /><div className="mt-2">No coupons yet</div></div>
        ) : items.map((c) => (
          <div key={c.id} className="px-5 py-3 flex items-center justify-between">
            <div>
              <span className="font-mono font-bold text-brand-navy">{c.code}</span>
              <span className="ml-3 text-sm text-brand-text">{c.discount_percent}% off</span>
              <span className="ml-3 text-xs text-brand-muted">{c.used_count}/{c.max_uses} used · expires {new Date(c.expires_at).toLocaleDateString()}</span>
            </div>
            <button onClick={() => remove(c.id)} className="p-1.5 text-red-500 hover:bg-red-50 rounded-lg"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
